import React from "react";
import { analytics } from '../utils/analytics';

const ContactSection = () => {
  const handleEmailClick = () => {
    analytics.contact.emailClick('mohonishm@gmail.com');
  };

  return (
    <section className="py-5" style={{ color: "#0d6efd" }} id="contact">
      <div className="container text-center">
        <p className="fs-5">
          Email:{" "}
          <a
            href="mailto:mohonishm@gmail.com"
            style={{ color: "#0d6efd", textDecoration: "underline" }}
            onClick={handleEmailClick}
          >
            mohonishm@gmail.com
          </a>
        </p>
      </div>
    </section>
  );
};

export default ContactSection;